import { render, staticRenderFns } from "./ThemeSetterMixin.js.vue?vue&type=template&id=c80a0b1c&"
import script from "./ThemeSetterMixin.js.vue?vue&type=script&lang=js&"
export * from "./ThemeSetterMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports